import * as React from "react";
const SvgUpArrow = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><path d="m12 3 8 9h-5v9H9v-9H4Z" /></svg>;
export default SvgUpArrow;